define((require) => {
    "use strict";

    var _               = require("underscore"),
        Marionette      = require("marionette"),
        Browser         = require("shared/services/Browser"),
        template        = require("ui/assets/youtube/YouTubeImageView.tpl"),
        Tooltip         = require("ui/common/Tooltip"),
        tooltipTemplate = require("ui/assets/youtube/YouTubeTooltipTemplate.tpl");

    var YOUTUBE = {
        fixedSize: {
            width: 480,
            height: 290
        }
    };

    /**
     * Item view for an image in the image library.
     *
     * @class ImageView
     * @constructor
     *
     * @cfg {Boolean} [enableDeletion] Whether to allow deletion of an image via the view.
     * @cfg {Boolean} [showImageInfo] Whether to display info about the image in the view.
     * @cfg {Boolean} [draggable] Whether the image view should be draggable.
     * @cfg {Boolean} [showTooltips] Whether to show a tooltip with image info when the view is hovered.
     */
    return Marionette.ItemView.extend({

        template: template,

        templateHelpers: function() {
            return {
                displayDuration: this.model.formatDuration()
            };
        },

        tooltipTemplate: tooltipTemplate,

        className: "youtube-image fade-in",

        modelEvents: {
            "change:isUsed": "render"
        },

        ui: {
            image: "img"
        },

        events: {
            "click": function() {
                // Trigger a "select" event on the 'this' element, this will allow the parent
                // view to easily setup a "select" listener, like <tt>events: {"select .youtube-image": function...}</tt>
                this.$el.trigger("select", this.model);
            },

            "dragstart": "_dragHandler"
        },

        _dragHandler: function(event) {
            // Firefox has a bug that causes it to offset the dragged image when displayed in a lightbox. Workaround is
            // to explicitly set the drag image to the dragged element.
            if (Browser.type.firefox) {
                event.originalEvent.dataTransfer.setDragImage(this.el, this.$el.width() / 2, this.$el.height() / 2);
            }

            var data = {
                type: "youtube",
                options: {
                    videoID: this.model.get("videoID"),
                    width: YOUTUBE.fixedSize.width,
                    height: YOUTUBE.fixedSize.height
                }
            };

            event.originalEvent.dataTransfer.setData("Text", JSON.stringify(data));

            // Cancel showing the bootstrap popover
            if (this.options.showTooltips) {
                this.ui.image.trigger("mouseout");
            }
        },

        initialize: function() {

        },

        onRender: function() {
            if (this.options.draggable) {
                this.ui.image.attr("draggable", "true");
            }

            if (this.options.showTooltips) {
                Tooltip.add(this.ui.image, {
                    content: this.createTooltipHtml(),
                    container: "body",
                    width: 200,
                    offset: {
                        align: "right",
                        elementWidth: 50
                    },
                    delay: {
                        show: 1000,
                        hide: 0
                    },
                    html: true
                });
            }
        },

        createTooltipHtml: function() {
            return tooltipTemplate(_.extend(
                {type: this.model.get("name").split(".").pop().toLowerCase()},
                this.model.toJSON()
            ));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/youtube/YouTubeImageView.js